import { useMutation, useQueryClient } from 'react-query';

import { putchEmailNotify as putch } from 'api/clients/putchEmailNotify';

const usePutchEmailNotify = () => {
  const queryClient = useQueryClient();
  const {
    isSuccess,
    mutate: putchEmailNotify,
    isLoading,
  } = useMutation(putch, {
    onSuccess: () => {
      queryClient.invalidateQueries('clients');
    },
  });

  return {
    isSuccess,
    putchEmailNotify,
    isLoading,
  };
};

export default usePutchEmailNotify;
